import { render, staticRenderFns } from "./ComprandoMasPagasMenos.vue?vue&type=template&id=2c395301&"
import script from "./ComprandoMasPagasMenos.vue?vue&type=script&lang=js&"
export * from "./ComprandoMasPagasMenos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports